const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:5001"
    : "");

export const FORUM_CATEGORIES = [
  "General",
  "Mechanical Engineering",
  "Process Engineering",
  "HAZOP/HAZID Study",
  "Project Management Consultancy",
  "Precommissioning & Commissioning",
  "Plant Drafting & 3D Modelling",
  "Petroleum & Gas Engineering",
  "Process Control/ Automation/ Instrumentation",
  "Petrochemical Engineering",
];

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (String(value).trim() === "") return;
    searchParams.set(key, String(value).trim());
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

const parseResponse = async (response) => {
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      body?.error || `Forum request failed (status ${response.status}).`
    );
  }

  return body;
};

const postJson = async (path, payload, headers = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(payload),
  });

  return parseResponse(response);
};

export const forumApi = {
  async getQuestions(params = {}) {
    const query = buildQueryString(params);
    const response = await fetch(`${API_BASE}/api/forum/questions${query}`);
    return parseResponse(response);
  },

  async getQuestion(slug) {
    const response = await fetch(
      `${API_BASE}/api/forum/questions/${encodeURIComponent(slug)}`
    );
    return parseResponse(response);
  },

  async submitQuestion(payload) {
    return postJson("/api/forum/questions", payload);
  },

  async submitReply(payload) {
    return postJson("/api/forum/replies", payload);
  },

  async getModerationQueue(adminSecret) {
    const response = await fetch(`${API_BASE}/api/forum/moderate`, {
      headers: {
        "x-admin-secret": adminSecret,
      },
    });

    return parseResponse(response);
  },

  async moderateItem(payload, adminSecret) {
    return postJson("/api/forum/moderate", payload, {
      "x-admin-secret": adminSecret,
    });
  },
};
